import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-field__toggle gfu-field-toggle--switch gfu-field-switch" }
const _hoisted_2 = ["name", "value", "disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
    "show-label": false,
    "display-name": $props.displayName
  }), {
    default: _withCtx(() => [
      _createElementVNode("label", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
          class: "gfu-field-switch__input",
          type: "checkbox",
          name: _ctx.name,
          value: $props.checkedValue,
          disabled: _ctx.readOnly || _ctx.disabled,
          onChange: _cache[1] || (_cache[1] = (...args) => ($options.onChange && $options.onChange(...args))),
          "data-qa": "switch-field-input"
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
          [_vModelCheckbox, _ctx.model]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["gfu-field-switch__slider", {'gfu-field-switch__slider--readonly': _ctx.readOnly }])
        }, null, 2 /* CLASS */),
        _createElementVNode("span", {
          class: "gfu-field-switch__label",
          onClick: _cache[2] || (_cache[2] = (...args) => ($options.onClick && $options.onClick(...args))),
          "data-qa": "switch-field-label"
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString($props.displayName), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["display-name"]))
}